export default "__VITE_ASSET__BVHZygh9__"